import apiService from "../../api/api.service";
import { WebVisitPayload, WebVisitResponse } from "./webVisit.types";

export const logWebVisit = (data: WebVisitPayload) => {
  return apiService.post<WebVisitResponse>("/general/log-web-visit", data);
};
